import SimpleMarkdown from 'components/SimpleMarkdown';
import { Accordion, Box, Tab, Tabs } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import { asset$ } from 'modules/asset/asset$';
import React, { useState } from 'react';
import { connect } from 'rxbeach/react';
import { combineLatest, map } from 'rxjs';
import styled from 'styled-components';
import { Asset } from 'types';
import { groupBy } from 'utils/dataUtils';
import { compare } from 'utils/sortUtils';
import { StyledChildBox, StyledPanel } from '../components/Atoms';

const viewModel$ = combineLatest([asset$]).pipe(
  map(([{ byId }]) => ({
    byTab: groupBy(
      Object.values(byId)
        .sort(compare('order'))
        .filter((e) => e.type === 'info'),
      'tab'
    ),
  }))
);

const MyTabs = styled(Tabs)`
  div:first-child {
    flex-wrap: wrap;
  }
`

const InfoHome = ({ byTab }: { byTab: Record<string, Asset[]> }) => {
  usePageTitle('Info');
  const [accordionIndex, setAccordionIndex] = useState<number | number[]>();
  if (!Object.entries(byTab)?.length) return null;
  return (
    <Box align="center" justify="center" pad="large">
      <MyTabs onActive={() => setAccordionIndex(-1)}>
        {Object.entries(byTab).map(([tab, items]) => (
          <Tab title={tab} key={tab}>
            <Box width="large">
              <Accordion
                activeIndex={accordionIndex}
                onActive={setAccordionIndex}
                animate={true}
              >
                {items.sort(compare('order')).map((item) => (
                  <StyledPanel label={item.label} key={item.id}>
                    <StyledChildBox>
                      <SimpleMarkdown key={item.id} asset={item} />
                    </StyledChildBox>
                  </StyledPanel>
                ))}
              </Accordion>
            </Box>
          </Tab>
        ))}
      </MyTabs>
    </Box>
  );
};

export default connect(InfoHome, viewModel$);
